export default "__VITE_ASSET__Crkp4e4e__"